const FAQ = [
  {
    question: "How long does a typical kitchen remodel take?",
    answer:
      "Most kitchen remodels<IN_CITY_ZIP> take between 6 to 10 weeks once construction begins. The full process, including design, permitting, and material selections, may add several weeks depending on the project's complexity.",
  },
  {
    question: "What’s the average cost of a kitchen remodel?",
    answer:
      "The average kitchen remodel<IN_CITY_ZIP> costs between $25,000 and $60,000. Smaller kitchens with standard upgrades may fall on the lower end, while full-scale or luxury remodels with custom cabinets and appliances can exceed $75,000.",
  },
  {
    question: "Do I need permits for a kitchen remodel?",
    answer:
      "Yes. Most kitchen remodels that involve plumbing, electrical, or structural updates require city permits<IN_CITY_ZIP>. We manage all permits, inspections, and approvals on your behalf.",
  },
  {
    question: "Can I use my kitchen during the remodel?",
    answer:
      "In most cases, your kitchen will be out of service during construction<IN_CITY_ZIP>. We recommend setting up a temporary cooking space, and we’ll help minimize disruption as much as possible.",
  },
  {
    question: "Will you help with the design and material selections?",
    answer:
      "Absolutely. Our team provides full design support — from space planning and cabinetry to countertops, backsplash, appliances, and fixtures — all tailored to your taste, lifestyle, and budget<IN_CITY_ZIP>.",
  },
  {
    question: "Do you offer financing options for kitchen remodels?",
    answer:
      "Yes. We offer flexible financing options, including $0 down and low monthly payments<IN_CITY_ZIP>. Pre-approval is quick and won’t impact your credit score.",
  },
  {
    question: "Why choose Modern Build for my kitchen remodel?",
    answer:
      "Modern Build delivers premium kitchen renovations<IN_CITY_ZIP> with expert project management, exceptional craftsmanship, and transparent communication. We specialize in creating stylish, functional kitchens that reflect your vision.",
  },
  {
    question: "What kitchen upgrades offer the best return on investment?",
    answer:
      "Popular upgrades that add strong value<IN_CITY_ZIP> include quartz countertops, new cabinetry, energy-efficient appliances, open-concept layouts, and updated lighting. We help you balance design impact with long-term ROI.",
  },
  {
    question: "Can you remodel a small or galley kitchen?",
    answer:
      "Yes. We specialize in maximizing space in small and galley kitchens<IN_CITY_ZIP> through smart layout design, custom cabinetry, and space-saving appliances. Even compact kitchens can become functional and stylish.",
  },
  {
    question: "Do you offer 3D renderings or design previews?",
    answer:
      "Yes. For kitchen remodels<IN_CITY_ZIP>, we can provide 3D renderings or layout previews to help you visualize the design before construction begins. It’s a great way to align on style and functionality early.",
  },
];

export default FAQ;
